module.exports = __webpack_public_path__ + "img/Dominica.36801c77.svg";